export enum VALID_ACTION {
  DOWNLOAD_DATA = 'DownloadData',
  BULK_CHANGE = 'bulkChange',
  BULK_EMAIL_SEND = 'bulkEmailSend',
}
